import React, { useContext, useEffect, useState } from 'react'
import { Fetcher } from '../../helpers/api/Fetcher';
import { language } from '../../App'
import H1 from '../../components/Fonts/H1/H1';
import { Col, Container, Row } from 'react-bootstrap';


const Adatvedelem = () => {
  const { currentLanguage } = useContext(language)
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchApi = async () => {
      const URL = 'https://beta.haromstudio.hu/scriptedprod/wp-json/wp/v2/pages/853';
      const res = await Fetcher({ URL, setIsLoading})
      setData(res)
    setIsLoading(false)

    }

    fetchApi()
  }, [currentLanguage])

  if (!isLoading) {
    return (
      <main className='adatvedelem'>
          <Container>
            <Row className='mt-4'>
              <Col xs={12}>
                <div className='block block-site-title mt-2'>
                  <H1 text={currentLanguage === 'hu' ? 'adatvédelem': 'adatvédelem'} />
                </div>
              </Col>
            </Row>
          </Container>

          {data?.content?.rendered ? (
            <Container>
              <Row className='mt-4'>
                <Col xs={12}>
                  <div className='block' dangerouslySetInnerHTML={{ __html: data.content.rendered }}></div>
                </Col>
              </Row>
            </Container>
          ) : (
            <p>Loading...</p>
          )}
      </main>
    )
  } else {
    return (
      <div className='body'></div>
    )
  }
}

export default Adatvedelem